import { LJ_COLORS, LJ_TYPE } from "@/lib/theme/lj";

/**
 * The magazine's advertising band.
 *
 * Every LJ slot used to be a bare caption over a bare creative, so a 300px unit
 * in a full-width rail sat in a field of page white with nothing to say where
 * the slot ended — the complaint the main site answered with a tinted band
 * (see `components/shared/main/ad-band.tsx`, and the SCMP treatment it cites).
 * QA: "for all ad units, add a background colour to text and the ad unit image
 * similar to the main hkej site".
 *
 * Same shape here, in LJ's own type and greys: the caption sits inside the
 * band above the creative, and the creative is flush — padding around it would
 * inset the image and read as a margin rather than as the slot's background.
 */
export function LjAdBand({
  label = "Advertisement",
  children,
  className = "",
}: {
  label?: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      data-ad-band=""
      className={`flex w-full flex-col items-center ${className}`}
      style={{ backgroundColor: "transparent" }}
    >
      <span
        className="block w-full text-center"
        style={{
          ...LJ_TYPE.byline,
          fontWeight: 300,
          color: LJ_COLORS.textSecondary,
          padding: "6px 0",
        }}
      >
        {label}
      </span>
      {children}
    </div>
  );
}
